/** @format */
import { createMachine } from 'xstate';

export enum RequestPasswordResetMachineAction {
    SUBMIT = 'submit',
}

export enum RequestPasswordResetMachineState {
    FORM = 'form',
    CONFIRMATION_PENDING = 'confirmation-pending',
}

export const requestPasswordResetMachine = createMachine({
    predictableActionArguments: true,
    id: 'request-password-reset-machine',
    initial: RequestPasswordResetMachineState.FORM,
    states: {
        [RequestPasswordResetMachineState.FORM]: {
            on: {
                [RequestPasswordResetMachineAction.SUBMIT]:
                    RequestPasswordResetMachineState.CONFIRMATION_PENDING,
            },
        },
        [RequestPasswordResetMachineState.CONFIRMATION_PENDING]: {},
    },
});
